export const ChevronIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
  <path d="M9.41309 2.96875L5.25796 7.12384C5.12596 7.25587 4.91195 7.25587 4.77995 7.12384L0.624819 2.96875" stroke="#6A6E6E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
